export const stripSerial = (s) => {
  s = String(s || "").trim();
  // Take the last "/sn/<serial>" occurrence — a fast scanner can concatenate a
  // repeated prefix (e.g. "htthttps://chasm.link/sn/…"); the final match is the real one.
  const all = [...s.matchAll(/\/sn\/([^/?#\s]+)/g)];
  if (all.length) return all[all.length - 1][1].trim();
  const m2 = s.match(/sn([A-Za-z0-9]+)$/i);
  if (m2) return m2[1].trim();
  if (s.includes("http")) {
    const p = s.replace(/\/$/, "").split("/");
    return p[p.length - 1].trim();
  }
  return s;
};

export const isUrl = (v) => v.includes("http") || v.includes("/sn/");

export const applyScanner = (prev, next, mode = "replace") => {
  const trimmed = next.trim();
  if (!isUrl(trimmed)) return next;
  const serial = stripSerial(trimmed);
  if (!serial) return next;
  if (mode === "append") {
    const base = prev.trimEnd();
    if (!base || base.endsWith(",")) return (base ? base + " " : "") + serial + ", ";
    return base + ", " + serial + ", ";
  }
  if (mode === "newline") {
    const base = prev.trimEnd();
    return base ? base + "\n" + serial : serial;
  }
  return serial;
};

// Scan feedback. Both are best-effort: vibration is unsupported on desktop and the
// AudioContext can be blocked until the page has been interacted with, so every
// call is wrapped and a failure is silently ignored.
let _scanAudioCtx = null;
const _getScanAudioCtx = () => {
  if (!_scanAudioCtx || _scanAudioCtx.state === "closed")
    _scanAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
  return _scanAudioCtx;
};

const _playTone = (frequency, duration, gainPeak, type = "sine") => {
  try {
    const ctx = _getScanAudioCtx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = type;
    osc.frequency.setValueAtTime(frequency, ctx.currentTime);
    gain.gain.setValueAtTime(0, ctx.currentTime);
    gain.gain.linearRampToValueAtTime(gainPeak, ctx.currentTime + 0.005);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration + 0.01);
  } catch (e) {}
};

export const buzzSuccess = () => {
  if (navigator.vibrate) navigator.vibrate(50);
  _playTone(1200, 0.12, 0.35);
};

export const buzzError = () => {
  if (navigator.vibrate) navigator.vibrate([50, 50, 100]);
  _playTone(280, 0.25, 0.4, "sawtooth");
};
